/*
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
*/

export default class Project {
    constructor(project) {
        this.project = project;
    }

    get projectId() {
        return this.project.projectId
    }

    get name() {
        return this.project.name
    }

    get active() {
        return this.project.active
    }

    get icon() {
        return "mdi-folder-open"
    }

    get color() {
        if (this.project.active == 1)
            return 'green'
        else
            return 'blue'
    }

    get projection() {
        return this.project.projection
    }
}
